import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { Button } from '@st-operations/uikit/src/v2'

import { logErrorAsync } from '_lib/utility'

import './SlidesErrorBoundary.scss'

const SlideErrorFallback = ({ boundaryProps: { resetErrorBoundary }, id }) => {
  return (
    <div className="slide-error-fallback">
      <h2 className="slide-error-fallback__header">Something went wrong!</h2>
      <p className="slide-error-fallback__message">
        Change your data and try again. If the error persists send a screenshot to support. This
        error is found only on this slide, the other slides can be used normally
      </p>
      <div className="slide-error-fallback__code">
        <p>ID: {id}</p>
        <p>Time: {new Date().toISOString()}</p>
      </div>
      <Button onClick={resetErrorBoundary}>Try again</Button>
    </div>
  )
}

const handleError = (error) => logErrorAsync(error)

const SlidesErrorBoundary = ({ id, children }) => {
  return (
    <ErrorBoundary
      fallbackRender={(boundaryProps) => (
        <SlideErrorFallback boundaryProps={boundaryProps} id={id} />
      )}
      onError={handleError}
    >
      {children}
    </ErrorBoundary>
  )
}

export default SlidesErrorBoundary
